// p is short for 'params' in an attempt to make paths and urls similar in length

export const getCheckListEdit   = (p) => `/scenario-type/${p.scenarioTypeID}/checklist`
export const getPhaseEdit       = (p) => `/scenario-type/${p.scenarioTypeID}/checklist/phase/${p.phaseIdx}`
export const getSubPhaseEdit    = (p) => `/scenario-type/${p.scenarioTypeID}/checklist/phase/${p.phaseIdx}/subphase/${p.subPhaseIdx}`

const editDistPromptPath               = "/scenario-type/:scenarioTypeID/interventions/distinguishing-prompts/:distPromptID"
export const getDistPromptEdit  = (p) => `/scenario-type/${p.scenarioTypeID}/interventions/distinguishing-prompts/${p.distPromptID}`
const editDistPromptsPath              = "/scenario-type/:scenarioTypeID/interventions/distinguishing-prompts"
export const getDistPromptsEdit = (p) => `/scenario-type/${p.scenarioTypeID}/interventions/distinguishing-prompts`
const editIntvMenuCatPath              = "/scenario-type/:scenarioTypeID/interventions/menu/:intvMenuCategoryID"
export const getIntvMenuCatEdit = (p) => `/scenario-type/${p.scenarioTypeID}/interventions/menu/${p}`
const editIntvsMenuPath                = "/scenario-type/:scenarioTypeID/interventions/menu"
export const getIntvMenusEdit   = (p) => `/scenario-type/${p.scenarioTypeID}/interventions/menu`
const editPromptPath                   = "/scenario-type/:scenarioTypeID/interventions/:interventionID/prompt/:promptID"
export const getPromptEdit      = (p) => `/scenario-type/${p.scenarioTypeID}/interventions/${p.interventionID}/prompt/${p.promptID}`
const editIntvPath                     = "/scenario-type/:scenarioTypeID/interventions/:interventionID"
export const getIntvEdit        = (p) => `/scenario-type/${p.scenarioTypeID}/interventions/${p.interventionID}`
const editIntvsPath                    = "/scenario-type/:scenarioTypeID/interventions"
export const getIntvsEdit       = (p) => `/scenario-type/${p.scenarioTypeID}/interventions`

export const getChecklistBC   = (p)        => ({ href: getCheckListEdit(p), label: "Sections" })
export const getPhaseBC       = (p, label) => ({ href: getPhaseEdit(p), label})
export const getSubPhaseBC    = (p, label) => ({ href: getSubPhaseEdit(p), label})

export const getIntvsBC       = (p)        => ({ href: getIntvsEdit(p),  label: "Interventions" })
export const getIntvBC        = (p, label) => ({ href: getIntvEdit(p), label })
export const getPromptBC      = (p, label) => ({ href: getPromptEdit(p), label})
export const getDistPromptsBC = (p)        => ({ href: getDistPromptsEdit(p), label: "Distinguishing Prompts"})
export const getDistPromptBC  = (p, label) => ({ href: getDistPromptEdit(p), label})
export const getIntvMenusBC   = (p)        => ({ href: getIntvMenusEdit(p), label: "Intervention Menu Categories" })
export const getIntvMenuCatBC = (p, label) => ({ href: getIntvMenuCatEdit(p), label})

export const getProblemsEdit = (p) => `/scenario/${p.scenarioId}/problems`
export const getProblemEdit  = (p) => `/scenario/${p.scenarioId}/problems/${p.probID}`
export const getSolutionEdit = (p) => `/scenario/${p.scenarioId}/problems/${p.probID}/solutions/${p.solID}`

export const getProblemsBC  = (p)        => ({ href: getProblemsEdit(p), label: "Problems"})
export const getProblemBC   = (p, label) => ({ href: getProblemEdit(p), label})
export const getSolutionBC  = (p, label) => ({ href: getSolutionEdit(p), label})

export const PATHS = {
    INTVS_LIST: editIntvsPath,
    INTV_EDIT: editIntvPath,
    PROMPT_EDIT: editPromptPath,
    INTV_MENUS_LIST: editIntvsMenuPath,
    INTV_MENU_CAT_EDIT: editIntvMenuCatPath,
    DIST_PROMPTS_LIST: editDistPromptsPath,
    DIST_PROMPT_EDIT: editDistPromptPath
}
